export function getBase64(file) {

    if (!file)
        return;

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

}

export function getFileBuffer(file) {

    if (!file)
        return;

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

}
export async function getWidthHeight(file) {

    var blob = URL.createObjectURL(file);
    let width = 1024;
    let height = 1024;

    let img = new Image();
    img.src = blob;
    await img.decode();

    let sizes = {
        width: width,
        height: height
    }
    return sizes;
}



export async function imageDataFromSource(sourceUrl) {

    console.log("url ", sourceUrl);
    var canvas = document.createElement('canvas');
    canvas.width = 1024;
    canvas.height = 1024;

    var ctx = canvas.getContext('2d');
    let img = new Image();

    img.src = sourceUrl;
    await img.decode();

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    //downloadImageURl(sourceUrl)
    const imagedata = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const datam = imagedata.data;
    return datam;
}



export async function downloadImageURl(sourceUrl) {

    var canvas = document.createElement('canvas');
    canvas.width = 1024;
    canvas.height = 1024;
    var ctx = canvas.getContext('2d');

    let img = new Image();
    img.src = sourceUrl;
    await img.decode();

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    let newImage = canvas.toDataURL('image/jpeg');
    const link = document.createElement("a");
    link.href = newImage;
    link.download = "downloadImage" + ".jpeg";
    link.click();

}




export async function downloadImageData(data) {

    var canvas = document.createElement('canvas');
    canvas.width = 1024;
    canvas.height = 1025;
    var ctx = canvas.getContext('2d');

    ctx.putImageData(data, 0, 0);

    let newImage = canvas.toDataURL('image/jpeg');
    const link = document.createElement("a");
    link.href = newImage;
    link.download = "mergedData" + ".jpeg";
    link.click();
}


export const getCanvas = () => {

    if (typeof document === 'undefined'
        && typeof OffscreenCanvas !== 'undefined') {
        return new OffscreenCanvas(1, 1);
    }
    return document.createElement('canvas');
}